import ReactTooltip from "react-tooltip";
import { Link } from "react-router-dom";
import Division from "../../../components/Division";
import Header from "../../../components/Header";
import Lateral from "../../../components/Lateral";
import { useEffect, useState } from "react";
import api from "../../../config";
import { toast } from "react-toastify";
import Page from "../../../components/BasePage";
import { getPermission, showMessageError } from "../../../classes/functions";
import { FaEye, FaPen } from "react-icons/fa";

export default function URLs(){
    const [carrying, setCarrying] = useState(false);
    const [search, setSearch] = useState("");
    const [itensByPage, setItensByPage] = useState(50);
    const [parametersURLs, setParametersURLs] = useState([]);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(1);

    function getURLs(){
        api
        .get(`/api/parametrosUrl?page=${page}&limit=${itensByPage}&search=${search}`)
        .then((response) => {
            setParametersURLs(response?.data?.result);
            setLimit(parseInt(response?.data?.total / itensByPage) + 1);
        })
        .catch((error) => {
            console.log(error);
            if(error.response.data.message){
                showMessageError(error.response.data);
            }
        });
    }

    useEffect(() => {
        getURLs();
    }, [, page, itensByPage, search]);

    return (
        <div>
            <Header/>
            <Division/>
            <Lateral/>
            <ReactTooltip />

            <Page carrying={carrying} setCarrying={setCarrying} URL={"urls"} search={search} setSearch={setSearch} itensByPage={itensByPage} setItensByPage={setItensByPage} limit={limit} page={page} setPage={setPage}>
                <div className="container">
                    <table>
                        <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Ativo</th>
                            <th>Host</th>
                            <th>Path</th>
                            <th>Funções</th>
                            <th>Descrição</th>
                            <th>Opções</th>
                        </tr>
                        </thead>
                        <tbody>
                            {parametersURLs.map((parameter, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{parameter?.nome}</td>
                                        <td>{parameter?.ativo === true ? "Sim" : "Não"}</td>
                                        <td>{parameter?.host}</td>
                                        <td>{parameter?.path}</td>
                                        <td>{parameter?.funcoes}</td>
                                        <td>{parameter?.descricao}</td>
                                        <td>
                                        {getPermission('CONFIGURACOES - URLS - CADASTRO') && <Link className="action" to={`/urls/cadastrar/u${parameter.id}`} >
                                            <FaPen color="#000" size={17} />
                                        </Link>}
                                        <Link className="action" to={`/urls/cadastrar/v${parameter.id}`} >
                                            <FaEye color="#000" size={19} />
                                        </Link>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </Page>
        </div>
    )
}